import { PunctualityFilterMeta } from '@src/main/modules/reports/ui/mapPunctualityFiltersToCriteria';
import { DataTableFilterMeta } from 'primereact/datatable';

export const usePunctualityFilterHandler = (
  setFilters: (filters: PunctualityFilterMeta) => void,
  refetchReports: () => void,
  setInvalidDateModalVisible: (visible: boolean) => void,
) => {
  const handleSetFilters = (newFilters: DataTableFilterMeta) => {
    const filtersTyped = newFilters as PunctualityFilterMeta;
    const flightDateFilter = filtersTyped.flightDate?.constraints?.[0]?.value ?? null;
    const updatedAtFilter = filtersTyped.updatedAt?.constraints?.[0]?.value ?? null;

    // Validate flight date range
    if (
      flightDateFilter !== null &&
      Array.isArray(flightDateFilter) &&
      flightDateFilter[0] instanceof Date &&
      flightDateFilter[1] instanceof Date &&
      flightDateFilter[0] > flightDateFilter[1]
    ) {
      setInvalidDateModalVisible(true);
      return;
    }

    // Validate updatedAt date range
    if (
      updatedAtFilter !== null &&
      Array.isArray(updatedAtFilter) &&
      updatedAtFilter[0] instanceof Date &&
      updatedAtFilter[1] instanceof Date &&
      updatedAtFilter[0] > updatedAtFilter[1]
    ) {
      setInvalidDateModalVisible(true);
      return;
    }

    setFilters(filtersTyped);
    refetchReports();
  };

  return { handleSetFilters };
};
